import { render } from "./LeaveApplicationsDashboardView.vue?vue&type=template&id=4a108dea&scoped=true"
import script from "./LeaveApplicationsDashboardView.vue?vue&type=script&lang=js"
export * from "./LeaveApplicationsDashboardView.vue?vue&type=script&lang=js"

import "./LeaveApplicationsDashboardView.vue?vue&type=style&index=0&id=4a108dea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a108dea"]])

export default __exports__